// src/layouts/services/index.jsx

import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import Footer from "examples/Footer";
import ServicesModal from "./components/ServicesModal";
import { MdChat } from "react-icons/md";

import { MdAutorenew } from "react-icons/md";
import {
  MdDesignServices,
  MdWeb,
  MdOutlineArticle,
  MdBuild,
  MdPayment,
  MdSecurity,
  MdTrendingUp,
  MdSmartToy,
  MdBrush,
} from "react-icons/md";

const services = [
  {
    icon: <MdDesignServices size={20} color="#A3E635" />,
    title: "UX & UI Design",
    description: "Criação de interfaces intuitivas e responsivas para sites, sistemas e aplicativos.",
    descriptionLong:
      "Atuação completa desde o wireframe até o design final, aplicando heurísticas de usabilidade e acessibilidade. Experiência com Figma, Adobe XD e integração com desenvolvimento frontend.",
    link: "/portfolio?filter=Web / UI"
  },
  {
    icon: <MdWeb size={20} color="#A3E635" />,
    title: "Sites e Landing Pages",
    description: "Desenvolvimento frontend com foco em performance e experiência do usuário.",
    descriptionLong:
      "Criação de páginas personalizadas com React, Next.js e Tailwind. Hospedagem otimizada, responsividade, SEO técnico e integrações com ferramentas de automação.",
    link: "/portfolio?filter=Web / UI" // "/portfolio?filter=Landing Pages" // ✅ vírgula estava faltando antes
  },
  {
    icon: <MdOutlineArticle size={20} color="#A3E635" />,
    title: "Copywriting",
    description: "Textos persuasivos para páginas, campanhas e automações.",
    descriptionLong:
      "Roteiros de vídeo, e-mails, landing pages e scripts comerciais com foco em storytelling e gatilhos mentais.",
    link: "/portfolio?filter=Marketing Digital" // ✅ vírgula estava faltando antes
  },
  {
    // icon: <MdBuild size={28} color="#A3E635" />,
    icon: <MdAutorenew size={20} color="#A3E635" />,
    title: "Micro SaaS & Automações",
    description: "Soluções sob medida com painéis inteligentes, APIs e IA generativa.",
    descriptionLong:
      "Criação de sistemas personalizados com dashboards em React ou Laravel, integração com bancos de dados e APIs de IA, automações com webhooks, e envio automático de relatórios.",
    link: "/portfolio?filter=Micro SaaS" // ✅ vírgula estava faltando antes
  },
  {
    icon: <MdPayment size={20} color="#A3E635" />,
    title: "Gateway & Pagamentos",
    description: "Integração de sistemas com intermediários como Asaas, Stripe, etc.",
    descriptionLong:
      "Checkout transparente, cobrança recorrente, pagamentos via Pix, cartão ou boleto, validação automática e sincronização com CRM.",
    link: "/portfolio?filter=IA e Automações" // ✅ vírgula estava faltando antes
  },
  {
    icon: <MdSecurity size={20} color="#A3E635" />,
    title: "Gestão de Sites & Domínios",
    description: "Hospedagem, segurança, e manutenção técnica de portais e sistemas.",
    descriptionLong:
      "Servidores otimizados, backups, SSL, DNS, integrações com e-mail profissional, relatórios de acesso, atualizações de plugins e estabilidade contínua.",
    link: "/portfolio?filter=Web / UI" // ✅ vírgula estava faltando antes
  },
  {
    icon: <MdTrendingUp size={20} color="#A3E635" />,
    title: "Marketing Digital",
    description: "Campanhas, criativos e tráfego pago com foco em conversão e resultados.",
    descriptionLong:
      "Gestão estratégica em plataformas como Meta Ads, Google Ads e RD Station. Criação de criativos visuais, copywriting e segmentação por personas.",
    link: "/portfolio?filter=Marketing Digital" // ✅ OK
  },
  {
    icon: <MdChat size={20} color="#A3E635" />,
    title: "Assistente com IA",
    description: "Automação de atendimento, formulários inteligentes e geração de conteúdo.",
    descriptionLong:
      "Integração de assistentes personalizados com IA generativa para atendimento ao cliente, suporte, coleta de dados e geração automática de texto. Uso de modelos como GPT, integração com APIs e bancos de dados, formulários inteligentes com e-mail automático.",
    link: "/portfolio?filter=IA e Automações" // ✅ OK
  },
  {
    icon: <MdBrush size={20} color="#A3E635" />,
    title: "Identidade Visual & Gráfica",
    description: "Criação de logomarcas, manuais de marca, editoriais e material impresso.",
    descriptionLong:
      "Criação e refinamento de identidades visuais com foco estratégico. Desenvolvimento de logotipos, papelaria, revistas, catálogos, folders e apresentações. Preparação técnica para impressão e versões digitais.",
    link: "/portfolio?filter=Design Gráfico" // ✅ OK
  }    
];

function ServicesPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const handleOpenModal = (service) => {
    setSelectedService(service);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedService(null);
  };

  return (
    <DashboardLayout>
      <DefaultNavbar /> {/* <DashboardNavbar /> */}
      <VuiBox py={3}>
        <Card>
          <CardContent>
            {/* Cabeçalho da seção */}
            <VuiBox mb={4} textAlign="center">
              <VuiTypography variant="h2" color="white" fontWeight="bold">
                Serviços e Soluções
              </VuiTypography>
              <VuiTypography
                variant="body2"
                color="text"
                sx={{
                  mt: 1, // 🟢 Espaçamento entre o título e o parágrafo
                  maxWidth: {
                    xs: "100%",   // em telas pequenas, ocupa tudo
                    sm: "90%",
                    md: "75%",
                    lg: "70%",    // limite em telas grandes
                    xl: "60%"     // ainda mais estreito em telas extra grandes
                  },
                  mx: "auto",      // centraliza horizontalmente
                  textAlign: "center",
                }}
              >
                Soluções sob demanda com visão estratégica em tecnologia, design e marketing digital.
                Atuação como profissional PJ para empresas, agências e gráficas que buscam inovação, performance
                e resultados mensuráveis — do conceito ao produto final.
              </VuiTypography>

            </VuiBox>

            {/* Cards de serviços */}
            <Grid container spacing={3} display="flex" flexWrap="wrap">
              {services.map((service, index) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                  <Card
                    sx={{
                      backgroundColor: "#1E1F2F",
                      borderRadius: "16px",
                      height: "100%",
                      p: 3,
                      cursor: "pointer",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 4px 20px rgba(163, 230, 53, 0.2)",
                      },
                    }}
                    onClick={() => handleOpenModal(service)}
                  >
                    <VuiBox
                      sx={({ palette, borders, functions, shadows }) => ({
                        backgroundColor: palette.sidenav.button,
                        minWidth: functions.pxToRem(40),
                        minHeight: functions.pxToRem(40),
                        borderRadius: borders.borderRadius.button,
                        display: "grid",
                        placeItems: "center",
                        boxShadow: shadows.md,
                        transition: "all 200ms ease-in-out",
                        mb: 2,
                        mx: "auto",
                      })}
                    >
                      {service.icon}
                    </VuiBox>

                    <VuiTypography variant="h5" color="white" fontWeight="bold" mb={1} textAlign="center">
                      {service.title}
                    </VuiTypography>
                    <VuiTypography variant="body2" color="text" textAlign="center">
                      {service.description}
                    </VuiTypography>
                  </Card>
                </Grid>
              ))}
            </Grid>

            {/* Modal de detalhes */}
            <ServicesModal
              open={modalOpen}
              onClose={handleCloseModal}
              service={selectedService}
            />
          </CardContent>
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ServicesPage;